// Leave Status Constants
export const PENDING_LEAVE_STATUS = "PENDING";
export const APPROVED_LEAVE_STATUS = "APPROVED";
export const REJECT_LEAVE_STATUS = "REJECTED";
export const CANCEL_LEAVE_STATUS = "CANCELLED";

// Action Types
export const REQUEST_LEAVE = "REQUEST_LEAVE";
export const APPROVE_LEAVE = "APPROVE_LEAVE";
export const REJECT_LEAVE = "REJECT_LEAVE";
export const CANCEL_LEAVE = "CANCEL_LEAVE";
export const GET_LEAVE_BY_USER = "GET_LEAVE_BY_USER";
export const GET_PENDING_LEAVE = "GET_PENDING_LEAVE";
export const GET_APPROVED_LEAVE = "GET_APPROVED_LEAVE";
export const GET_REJECTED_LEAVE = "GET_REJECTED_LEAVE";
export const GET_CANCLED_LEAVE = "GET_CANCLED_LEAVE";